import {emojiRegex} from './emojiRegex';

/**
 * @name removeEmojis
 */
export const removeEmojis = (string: string): string =>
  string.replace(emojiRegex, '');
